Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.LastUpdatedDateView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/last_updated']
  className: 'mr-4 last-updated'
  tagName: 'span'

  initialize: ({lastUpdatedDate}) ->
    @lastUpdatedDate = lastUpdatedDate

  render: ->
    @$el.html @template
      lastUpdatedDate: @lastUpdatedDate
    @

  setLastUpdatedDate: (lastUpdateDate) ->
    @lastUpdatedDate = lastUpdateDate
